import { render, staticRenderFns } from "./captains.vue?vue&type=template&id=745318c7&scoped=true&"
import script from "./captains.vue?vue&type=script&lang=js&"
export * from "./captains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745318c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745318c7')) {
      api.createRecord('745318c7', component.options)
    } else {
      api.reload('745318c7', component.options)
    }
    module.hot.accept("./captains.vue?vue&type=template&id=745318c7&scoped=true&", function () {
      api.rerender('745318c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/captains.vue"
export default component.exports